"use client";

import useUserDevice from "./useUserDevice";
import { useEffect, useState } from "react";

type VideoConstraints = {
    frameRate: number;
    height?: number | object;
    width?: number | object;
    aspectRatio?: number;
    facingMode?: "user" | "environment";
};

const useVideoConstraints = (isOnline: boolean, mediaError: boolean) => {
    const { device } = useUserDevice();

    const [videoConstraints, setVideoConstraints] = useState<VideoConstraints>({
        frameRate: 0,
    });

    useEffect(() => {
        setVideoConstraints((prevState) => {
            console.log("mediaError " + mediaError);
            if (isOnline) {
                // byod indvidual settings
                const dp = window.devicePixelRatio;
                const availAspectRatio = window.screen?.availWidth / window.screen?.availHeight ?? 1;

                console.debug(
                    "Video Constraints :",
                    `width: ${window.screen?.availWidth}`,
                    `height: ${window.screen?.availHeight}`,
                    `dp: ${window.devicePixelRatio}`,
                    `orientation: ${window.screen?.orientation?.type}`,
                );

                if (window.screen?.orientation?.type === "portrait-primary") {
                    //on some samsung devices this is the only way the camera works
                    if (mediaError) {
                        return {
                            ...prevState,
                            frameRate: 30,
                            facingMode: "user",
                            height: { min: 480 },
                            aspectRatio: 1,
                        };
                    }
                    // on devices in portrait mode, width and height must be flipped
                    return {
                        ...prevState,
                        frameRate: 30,
                        facingMode: "user",
                        height: { ideal: window.screen?.availWidth * dp }, // width property is height of portrait video
                        aspectRatio: 1 / availAspectRatio,
                    };
                } else {
                    return {
                        ...prevState,
                        frameRate: 30,
                        facingMode: "user",
                        width: { ideal: window.screen?.availWidth * dp },
                        height: { ideal: window.screen?.availWidth * dp },
                        aspectRatio: availAspectRatio,
                    };
                }
            } else {
                // fixed settings for stele
                return {
                    ...prevState,
                    frameRate: 30,
                    width: 3840,
                    height: 2160,
                };
            }
        });
    }, [device, mediaError]);

    const toggleCameraDirection = () => {
        setVideoConstraints((prevState) => {
            if (device?.isHandheld && isOnline) {
                console.log("change");
                const dp = window.devicePixelRatio;
                const availAspectRatio = window.screen.availWidth / window.screen.availHeight;

                console.debug(
                    "Video Constraints :",
                    `width: ${window.screen?.availWidth}`,
                    `height: ${window.screen?.availHeight}`,
                    `orientation: ${window.screen?.orientation?.type}`,
                );

                if (window.screen?.orientation?.type === "portrait-primary") {
                    // on devices in portrait mode, width and height must be flipped
                    return {
                        ...prevState,
                        facingMode: prevState.facingMode === "user" ? "environment" : "user",
                    };
                } else {
                    return {
                        ...prevState,
                        facingMode: prevState.facingMode === "user" ? "environment" : "user",
                    };
                }
            }
            return prevState;
        });
    };

    return { videoConstraints, toggleCameraDirection };
};

export default useVideoConstraints;
